import React, { useEffect, useState } from "react";
import axios from "axios";
import packageJson from '../../../package.json';
import { Link } from "react-router-dom";
const BASE_URL = packageJson.apiUrl;

const BlogCard = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true); // State to track loading status
    const [error, setError] = useState(""); // State to track errors

    useEffect(() => {
        // Fetching blog data from the API
        axios
            .get(`${BASE_URL}/blog/list`)
            .then((response) => {
                if (response.data.success) {
                    setBlogs(response.data.data); // Set blog data
                }
                setLoading(false); // Set loading to false after data is fetched
            })
            .catch((error) => {
                console.error("There was an error fetching the blog!", error);
                setError("Error fetching blogs. Please try again later.");
                setLoading(false); // Set loading to false even in case of error
            });
    }, []);

    if (loading) {
        return <p>Loading blogs...</p>; // Show loading message
    }

    if (error) {
        return <p>{error}</p>; // Show error message if there's an error
    }

    if (blogs.length === 0) {
        return <p>No blogs available.</p>; // Show message if no blogs are available
    }
const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
  };
    return (
	<div className="col-lg-3 col-md-4">
        <div className="blog-list">
            {blogs.map((blog) => (
                <div className="blog-box" key={blog.id}>
                    <div className="blog-img">
                       <Link to={`/blog-detail/${blog.id}`} onClick={() => handleClick(blog.name)}>
                            <img src={blog.image} className="img-fluid" alt={blog.name} />
                        </Link>
                    </div>
                    <div className="blog-con">
                        <p className="blog-tag">
                            <i className="bi bi-folder2-open"></i> Author: {blog.authorname}
                        </p>
                        <Link to={`/blog-detail/${blog.id}`} onClick={() => handleClick(blog.name)}className="blog-title">
                            {blog.name}
                        </Link>
						<p
                    className="blog-des"
                    dangerouslySetInnerHTML={{
                      __html:
                        blog.description.length > 100
                          ? blog.description.slice(0, 100) + "..."
                          : blog.description,
                    }}
                  />
                        <Link to={`/blog-detail/${blog.id}`} onClick={() => handleClick(blog.name)}className="blog-read">
                            Read More <i className="bi bi-arrow-right-circle"></i>
                        </Link>
                    </div>
                </div>
            ))}
        </div>
		</div>
    );
};

export default BlogCard;
